import React from 'react'
import { truncate } from '~/helpers/truncate-text'
import dayjs from 'dayjs'
import 'dayjs/locale/fr'
const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

const Card = ({ children, locale }) => {
  const { title, place, url, photos, date, hour } = children
  const hasPhoto = photos.photo1 != null

  const saleTypes = {
    volontaire: 'bg-blue',
    judiciaire: 'bg-green',
    mixte: 'bg-black',
  }

  const salePlace = {
    Besançon: "11, rue de l'Église - 25000 Besançon",
    Belfort: "2 bis, avenue de l'Espérance - 90000 Belfort",
    Colmar: '33, rue de Turenne - 68000 Colmar',
    Vesoul: '98, boulevard des Alliés - 70000 Vesoul',
  }

  const parsedDate = dayjs(date, 'DD/MM/YY').locale(locale).format('ddd DD MMM')
  const parsedHour = hour.replace(/:/g, 'h')

  return (
    <div className="py-3">
      <a
        className="hover:no-underline text-black"
        href={url}
        target="_blank"
        rel="noreferrer"
      >
        <div className="transition duration-200 ease-in-out mb-14 h-full shadow-md hover:shadow-lg bg-white overflow-hidden p-5">
          <div className="text-center">
            <div className="mb-1">
              <h2 className="inline font-bold">{title}</h2>
              <span className="live">Live</span>
            </div>
            {/* <div className={`mb-2 text-white uppercase px-2 w-min rounded-full ${saleTypes ? saleTypes[type] : ''}`}>{type}</div> */}
            <div className="text-gray-700">
              <div className="text-xl">
                {parsedDate} - {parsedHour}
              </div>
              <div>{salePlace[place]}</div>
            </div>
          </div>
          {hasPhoto && (
            <div className="flex flex-wrap -mx-3 my-2">
              {Object.values(photos).map(
                url =>
                  url !== null && (
                    <div className="w-1/2 tablet:w-1/4 my-3 tablet:mt-5 tablet:mb-2 px-3">
                      <img
                        className="w-full h-9 tablet:h-10 object-cover"
                        src={url}
                        alt={title}
                        width={200}
                      />
                    </div>
                  )
              )}
            </div>
          )}
          <div
            className={`flex items-center text-blue ${
              hasPhoto ? 'float-right' : 'justify-center mt-3'
            } text-lg`}
          >
            {locale === 'fr' &&
              (hasPhoto ? (
                <span>Voir tous les lots</span>
              ) : (
                <span>Voir les détails</span>
              ))}
            {locale === 'en' &&
              (hasPhoto ? (
                <span>See all articles</span>
              ) : (
                <span>See more details</span>
              ))}
            <img
              className="w-3 ml-1"
              src="/arrow-right.png"
              alt="arrow right"
            />
          </div>
        </div>
      </a>
    </div>
  )
}

export default Card
